import {
  Menu as ChakraMenu,
  MenuProps as ChakraMenuProps,
  MenuButton as ChakraMenuButton,
  MenuList as ChakraMenuList,
  MenuItem as ChakraMenuItem,
} from "@chakra-ui/react";

export function Menu(props: ChakraMenuProps) {
  return <ChakraMenu {...props} />;
}

Menu.Trigger = ChakraMenuButton;
Menu.List = ChakraMenuList;
Menu.Item = ChakraMenuItem;
